"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
exports.__esModule = true;
exports.newPickerItem = exports.DsSgPicker = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _components = require("@sg-bootstrap/components/dist/react-library/src/components");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// @ts-nocheck

var newPickerItem = exports.newPickerItem = function newPickerItem(value) {
  return {
    desc: value,
    key: value,
    label: value,
    type: 'item',
    selected: true
  };
};
var DsSgPicker = exports.DsSgPicker = function DsSgPicker(_ref) {
  var placeholder = _ref.placeholder,
    singleSelect = _ref.singleSelect,
    onlyDisplaceNumberOfSelectedItems = _ref.onlyDisplaceNumberOfSelectedItems,
    maxSelectedItems = _ref.maxSelectedItems,
    customClasses = _ref.customClasses,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'search' : _ref$icon,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'default' : _ref$state,
    _ref$validationMessag = _ref.validationMessage,
    validationMessage = _ref$validationMessag === void 0 ? 'Input error!' : _ref$validationMessag,
    items = _ref.items,
    onChangeItemsSelected = _ref.onChangeItemsSelected,
    _ref$externalUpdate = _ref.externalUpdate,
    externalUpdate = _ref$externalUpdate === void 0 ? false : _ref$externalUpdate,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$createTag = _ref.createTag,
    createTag = _ref$createTag === void 0 ? false : _ref$createTag,
    _ref$noIcon = _ref.noIcon,
    noIcon = _ref$noIcon === void 0 ? false : _ref$noIcon;
  var sgPickerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _a;
    (_a = sgPickerRef.current) === null || _a === void 0 ? void 0 : _a.setItems(items);
  }, [externalUpdate]);
  function addListener(refObject) {
    var _a, _b, _c;
    (_a = refObject.current) === null || _a === void 0 ? void 0 : _a.addEventListener('selectItem', handleEvent);
    (_b = refObject.current) === null || _b === void 0 ? void 0 : _b.addEventListener('unselectItem', handleEvent);
    (_c = refObject.current) === null || _c === void 0 ? void 0 : _c.addEventListener('clear', handleEvent);
  }
  function removeListener(refObject) {
    var _a, _b, _c;
    (_a = refObject.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('selectItem', handleEvent);
    (_b = refObject.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('unselectItem', handleEvent);
    (_c = refObject.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('clear', handleEvent);
  }
  var handleSelectedItems = function handleSelectedItems(sgPickerItems) {
    var _a;
    var selectedItems = sgPickerItems.filter(function (pickerItem) {
      return pickerItem.selected;
    });
    if (maxSelectedItems) {
      var type = selectedItems.length >= maxSelectedItems ? 'info' : 'item';
      var keys = selectedItems.map(function (value) {
        return value.key;
      });
      var transformedPickerItems = items.map(function (sgPickerItem) {
        if (keys.includes(sgPickerItem.key)) {
          return Object.assign(Object.assign({}, sgPickerItem), {
            selected: true
          });
        } else {
          return Object.assign(Object.assign({}, sgPickerItem), {
            type: type,
            selected: false
          });
        }
      });
      (_a = sgPickerRef === null || sgPickerRef === void 0 ? void 0 : sgPickerRef.current) === null || _a === void 0 ? void 0 : _a.setItems(transformedPickerItems);
    }
    onChangeItemsSelected(sgPickerItems);
  };
  var handleEvent = function handleEvent() {
    var _a;
    (_a = sgPickerRef === null || sgPickerRef === void 0 ? void 0 : sgPickerRef.current) === null || _a === void 0 ? void 0 : _a.getItems().then(handleSelectedItems);
  };
  var handleReady = function handleReady() {
    var _a;
    removeListener(sgPickerRef);
    (_a = sgPickerRef.current) === null || _a === void 0 ? void 0 : _a.setItems(items).then(function () {
      addListener(sgPickerRef);
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SgPicker, {
    ref: sgPickerRef,
    placeholder: placeholder,
    singleSelect: singleSelect,
    color: 'info',
    summary: onlyDisplaceNumberOfSelectedItems,
    classes: customClasses,
    size: size,
    icon: icon,
    noIcon: noIcon,
    state: state,
    validationMessage: validationMessage,
    onReady: handleReady,
    disabled: disabled,
    createTag: createTag
  });
};